if (!Object.groupBy) {
  Object.groupBy = function <K extends PropertyKey, T>(
    items: Iterable<T>,
    callback: (item: T, index: number) => K
  ): Partial<Record<K, T[]>> {
    if (items == null) {
      throw new TypeError("Object.groupBy called on null or undefined");
    }
    if (typeof callback !== "function") {
      throw new TypeError("callback must be a function");
    }

    const result: Partial<Record<K, T[]>> = {};
    let i = 0;
    for (const value of items) {
      const key = callback(value, i);

      if (!result[key]) {
        result[key] = [];
      }
      result[key]!.push(value);
      i++;
    }
    return result;
  };
}